export default __webpack_public_path__ + "static/media/serviceImg5.3f4b5a22.svg";